import {Component, OnInit, ViewChild, ViewEncapsulation} from '@angular/core';
import { NutritionFacadeService } from '@emm/management/services/nutrition-facade.service';
import {
    NutritionAssignmentsFormComponent
} from '@emm/management/components/nutrition-assignments/nutrition-assignments-form/nutrition-assignments-form.component';
import {UserService} from '@emm/core/services/user.service';
import {NotificationService} from '@emm/shared/services/notification.service';
import {API_ERRORS} from '@emm/core/util/api-constants';

@Component({
    encapsulation: ViewEncapsulation.None,
    selector: 'emm-management-nutrition-assignments',
    styleUrls: ['./nutrition-assignments.component.scss'],
    templateUrl: './nutrition-assignments.component.html',
    standalone: false
})
export class NutritionAssignmentsComponent implements OnInit{

    @ViewChild(NutritionAssignmentsFormComponent) nutritionForm: NutritionAssignmentsFormComponent;

    centerLoading$ = this.nutritionFacade.centerLoading$;
    buttonsState = { disableCancel: true, disableSave: true };
    locationSetType$ = this.nutritionFacade.locationSetType$;
    rightLoading$ = this.nutritionFacade.rightLoading$;
    assignment$ = this.nutritionFacade.assignment$;
    locationSet$ = this.nutritionFacade.location$;
    isReadOnly = this.userService.hasLoginRole();
    isSuperAdmin = this.userService.hasSuperAdminRole();
    isAdmin = this.userService.hasAdminRole();
    isAuthor = this.userService.hasAuthorRole();
    showPublish$ = this.nutritionFacade.showPublish$;

    constructor(private nutritionFacade: NutritionFacadeService,
                private userService: UserService,
                private notificationService: NotificationService) {}

    ngOnInit(): void {
        this.nutritionFacade.initNutrition();
        this.nutritionFacade.loadProfileOptions();
        this.showPublish$.next(this.nutritionFacade.isSuperAdminOrAdmin);
    }

    handleCancel(): void {
        this.nutritionForm.cancel();
    }

    handleSubmit(): void {
        this.nutritionForm.submit();
    }

    handlePublish(): void {
        const locationInfo = this.nutritionFacade.getLocationInfo();
        this.nutritionFacade.publishNutrition(locationInfo?.locationType, locationInfo?.location)?.subscribe({
            next: () => {
                this.notificationService.success(`Successfully published Nutrition for ${locationInfo?.location.tag}`);
            },
            error: (error) => {
                this.notificationService.error(error?.error?.error?.message || API_ERRORS.GenericErrorMessage);
            }
        });
    }
}
